import React from 'react';
import { usePlanningBottomupState } from '../Context/index';

export function UKRetailSv() {
  const { planningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedDisplayColumn } = planningBottomup;

  const ulRetailSvGrossFeilds = [
    // {
    //   keyName: "ukRetailSvGross",
    //   name: `${ukDisplay ? "UK " : ""}Retail SV Gross`,
    // },
    // {
    //   keyName: "ukRetailMarginPer",
    //   name: `${ukDisplay ? "UK " : ""}Retail Margin %`,
    // },
  ];
  if (ulRetailSvGrossFeilds.length === 0) {
    return null;
  }
  const isTableVisible = ulRetailSvGrossFeilds?.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));
  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {ulRetailSvGrossFeilds?.map((ukRetailItem, i) => {
              const isVisible = checkVisibleBottomUp(ukRetailItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{ukRetailItem?.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {ulRetailSvGrossFeilds?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible && (
                      <td key={iTD} className="text-right">
                        {trItem[tdItem?.keyName]}
                        {tdItem?.keyName === 'ukRetailMarginPer' && '%'}
                      </td>
                    )
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default UKRetailSv;
